import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import type { CompanyClientStatusApi } from '@/modules/companies/types';
import type { JobState } from '@/modules/jobs/jobStates';

export interface JobFilters {
  companyId?: string;
  userIds?: string[];
  state?: JobState;
  companyClientStatuses?: CompanyClientStatusApi[];
}

interface JobsStore {
  filters: JobFilters;
  actions: {
    setFilters: (filters: Partial<JobFilters>) => void;
    clearFilters: () => void;
  };
}

const useJobsStore = create<JobsStore>()(
  persist(
    (set) => ({
      filters: {},
      actions: {
        setFilters: (newFilters) =>
          set((state) => ({
            filters: {
              ...state.filters,
              ...newFilters,
            },
          })),
        clearFilters: () => set({ filters: {} }),
      },
    }),
    {
      name: 'jobs-filters',
      partialize: (state) => ({
        filters: state.filters,
      }),
    },
  ),
);

export const useJobFilters = () => useJobsStore((state) => state.filters);

export const useJobsActions = () => useJobsStore((state) => state.actions);
